export default __webpack_public_path__ + "images/1079ab94a298d5069e05b943c7ac948f-san_francisco_mobile.webp";